import React from "react";
import { View, SafeAreaView, TouchableOpacity } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { AppText } from "@/components/AppText";

type Props = {
  onRetry: () => void;
};

const ErrorState: React.FC<Props> = ({ onRetry }) => (
  <SafeAreaView style={styles.container}>
    <View style={styles.emptyState}>
      <AppText style={styles.emptyStateTitle}>Unable to load offers</AppText>
      <AppText style={styles.emptyStateText}>
        Please check your connection and try again
      </AppText>
      <TouchableOpacity style={styles.retryButton} onPress={onRetry}>
        <AppText style={styles.retryButtonText}>Retry</AppText>
      </TouchableOpacity>
    </View>
  </SafeAreaView>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F8FAFC",
  },
  emptyState: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 32,
    paddingVertical: 64,
  },
  emptyStateTitle: {
    fontSize: 20,
    fontWeight: "600",
    color: "#1F2937",
    marginBottom: 8,
    textAlign: "center",
  },
  emptyStateText: {
    fontSize: 16,
    color: "#6B7280",
    textAlign: "center",
    lineHeight: 24,
    marginBottom: 24,
  },
  retryButton: {
    backgroundColor: "#4F46E5",
    paddingHorizontal: 24,
    paddingVertical: 12,
    borderRadius: 8,
  },
  retryButtonText: {
    color: "#FFFFFF",
    fontSize: 16,
    fontWeight: "600",
  },
});

export default ErrorState;
